import React, { Fragment as _ } from 'react';

const AssessmentQuestion = ({ children, ...props }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'lime',
      }}
    >
      <h1>Assessment Question</h1>
    </div>
  );
};

export default AssessmentQuestion;
